import { render, staticRenderFns } from "./FilterChips.vue?vue&type=template&id=4280379c&scoped=true&lang=pug"
import script from "./FilterChips.vue?vue&type=script&lang=js"
export * from "./FilterChips.vue?vue&type=script&lang=js"
import style0 from "./FilterChips.vue?vue&type=style&index=0&id=4280379c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4280379c",
  null
  
)

export default component.exports